// app/javascript/controllers/reveal_secret_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "span"]
  static values = { secret: String }

  reveal() {
    // Mode 1: Input field (new/edit form)
    if (this.hasInputTarget) {
      const input = this.inputTarget
      const originalType = input.type

      input.type = "text"

      setTimeout(() => {
        input.type = originalType
      }, 8000)

      return
    }

    // Mode 2: Span on index page
    if (this.hasSpanTarget && this.secretValue) {
      const span = this.spanTarget
      const originalText = span.innerText

      span.innerText = this.secretValue

      // Hide again after 8 seconds
      setTimeout(() => {
        span.innerText = originalText
      }, 8000)
    }
  }
}
